export default __webpack_public_path__ + "static/media/arrow_up.3267f061.svg";